import React, { useEffect } from 'react';
import Input from '../CustomInput/CustomInput';
import useStyles from './CodigoValidacionStyles';
var codigoCompleto = ['', '', '', '', '', ''];
var CodigoValidacion = function (_a) {
    var error = _a.error, value = _a.value, name = _a.name, disabled = _a.disabled, onValueChange = _a.onValueChange;
    var formulario = document.getElementById('groupInput');
    var inputs = formulario === null || formulario === void 0 ? void 0 : formulario.querySelectorAll('input');
    var styles = useStyles();
    var REGEX_SOLO_NUMERO = /[0-9]/;
    var KEY_BACKSPACE = 8;
    var KEY_DELETE = 46;
    var clearInputs = function () {
        inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function (input) {
            var valueInput = input;
            valueInput.value = '';
        });
    };
    useEffect(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
            clearInputs();
        }
    }, [value]);
    var valueChangeHandler = function (event, index) {
        if (event.target.value !== '') {
            codigoCompleto[index] = event.target.value;
            onValueChange(codigoCompleto.join(''), name);
        }
    };
    /**
     * Cambia de foco al escribir el código.
     * @param event evento de DOM
     */
    var handlerOnInput = function (event, index) {
        var input = event.target;
        if (input.nextElementSibling && input.value) {
            input.nextElementSibling.focus();
        }
        valueChangeHandler(event, index);
    };
    /**
     * Restringe el pegado a solo número
     * @param event evento de DOM
     */
    var handlePaste = function (event) {
        var paste = event.clipboardData.getData('text');
        if (Number(paste)) {
            inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function (input, i) {
                var valueInput = input;
                valueInput.value = paste[i] || '';
                codigoCompleto[i] = paste[i];
            });
            inputs === null || inputs === void 0 ? void 0 : inputs[(inputs === null || inputs === void 0 ? void 0 : inputs.length) - 1].focus();
        }
        else {
            event.preventDefault();
        }
    };
    /**
     * Restringe el escribir a solo número
     * @param event evento de DOM
     */
    var handlerOnKeyPress = function (event) {
        if (!REGEX_SOLO_NUMERO.test(event.key)) {
            event.preventDefault();
        }
    };
    /**
     * Cambia de foco al eliminar el código.
     * @param index posición actual
     * @param event evento de DOM
     */
    var handlerOnKeyUp = function (index, event) {
        var key = event.keyCode || event.charCode;
        if ((key === KEY_BACKSPACE || key === KEY_DELETE) && inputs !== undefined && index !== 0) {
            codigoCompleto[index] = '';
            inputs[index - 1].focus();
        }
    };
    /**
     * Agrega el valor de "CodigoCompleto" a cada posición entregada por el evento
     * @param index posición actual
     * @param event evento de DOM
     */
    var handlerOnBlur = function (index, event) {
        valueChangeHandler(event, index);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { className: styles.form_input, dataTestId: name, name: name, value: value, onBlur: function () { }, onChange: function () { }, errors: error }),
        React.createElement("section", { id: "groupInput", className: styles.inputs },
            React.createElement("input", { className: styles.input, type: "tel", name: "n1", placeholder: " ", autoComplete: "off", "data-testid": "n1", onBlur: function (event) { return handlerOnBlur(0, event); }, onKeyUp: function (event) { return handlerOnKeyUp(0, event); }, onPaste: function (event) { return handlePaste(event); }, onKeyPress: function (event) { return handlerOnKeyPress(event); }, onInput: function (event) { return handlerOnInput(event, 0); }, maxLength: 1, disabled: disabled }),
            React.createElement("input", { className: styles.input, type: "tel", name: "n2", placeholder: " ", autoComplete: "off", "data-testid": "n2", onBlur: function (event) { return handlerOnBlur(1, event); }, onKeyUp: function (event) { return handlerOnKeyUp(1, event); }, onPaste: function (event) { return handlePaste(event); }, onKeyPress: function (event) { return handlerOnKeyPress(event); }, onInput: function (event) { return handlerOnInput(event, 1); }, maxLength: 1, disabled: disabled }),
            React.createElement("input", { className: styles.input, type: "tel", name: "n3", placeholder: " ", autoComplete: "off", "data-testid": "n3", onBlur: function (event) { return handlerOnBlur(2, event); }, onKeyUp: function (event) { return handlerOnKeyUp(2, event); }, onPaste: function (event) { return handlePaste(event); }, onKeyPress: function (event) { return handlerOnKeyPress(event); }, onInput: function (event) { return handlerOnInput(event, 2); }, maxLength: 1, disabled: disabled }),
            React.createElement("input", { className: styles.input, type: "tel", name: "n4", placeholder: " ", autoComplete: "off", "data-testid": "n4", onBlur: function (event) { return handlerOnBlur(3, event); }, onKeyUp: function (event) { return handlerOnKeyUp(3, event); }, onPaste: function (event) { return handlePaste(event); }, onKeyPress: function (event) { return handlerOnKeyPress(event); }, onInput: function (event) { return handlerOnInput(event, 3); }, maxLength: 1, disabled: disabled }),
            React.createElement("input", { className: styles.input, type: "tel", name: "n5", placeholder: " ", autoComplete: "off", "data-testid": "n5", onBlur: function (event) { return handlerOnBlur(4, event); }, onKeyUp: function (event) { return handlerOnKeyUp(4, event); }, onPaste: function (event) { return handlePaste(event); }, onKeyPress: function (event) { return handlerOnKeyPress(event); }, onInput: function (event) { return handlerOnInput(event, 4); }, maxLength: 1, disabled: disabled }),
            React.createElement("input", { className: styles.input, type: "tel", name: "n6", placeholder: " ", autoComplete: "off", "data-testid": "n6", onBlur: function (event) { return handlerOnBlur(5, event); }, onKeyUp: function (event) { return handlerOnKeyUp(5, event); }, onPaste: function (event) { return handlePaste(event); }, onKeyPress: function (event) { return handlerOnKeyPress(event); }, onInput: function (event) { return handlerOnInput(event, 5); }, maxLength: 1, disabled: disabled }),
            React.createElement("section", { className: styles.error }, error))));
};
CodigoValidacion.defaultProps = {
    value: '',
};
export default CodigoValidacion;
